import { RemoveScroll } from 'react-remove-scroll'

import { Stack } from '@awaze/design-system.components.stack'
import {
  SearchFormConfig,
  SearchFormFields,
} from '@awaze/design-system.compositions.search-form'

import { SearchFormComponent } from '@/components/SearchForm'
import { SearchResultsTranslations } from '@/types'

import {
  MapViewSearchControlsMobileWrapper,
  StyledDesktopMapContainer,
  StyledMapContainer,
} from './ConditionalMapBlock.styles'

interface ConditionalMapBlockProps {
  isDesktop: boolean
  openFilters: () => void
  defaultConfig: SearchFormConfig
  initialValues: SearchFormFields
  locale: string
  marketCode: string
  children: React.ReactNode
  translations: SearchResultsTranslations
  enableRemoveScroll: boolean
}

export const ConditionalMapBlock: React.FC<ConditionalMapBlockProps> = ({
  isDesktop,
  openFilters,
  defaultConfig,
  initialValues,
  locale,
  marketCode,
  children,
  translations: { searchformTranslations },
  enableRemoveScroll,
}) => {
  if (isDesktop) {
    return <StyledDesktopMapContainer>{children}</StyledDesktopMapContainer>
  }

  return (
    <RemoveScroll enabled={enableRemoveScroll}>
      <StyledMapContainer>
        <Stack fullWidth fullHeight spacing={0}>
          <MapViewSearchControlsMobileWrapper>
            <SearchFormComponent
              openFilters={openFilters}
              defaultConfig={defaultConfig}
              initialValues={initialValues}
              locale={locale}
              marketCode={marketCode}
              mobileStickyMode={false}
              translations={searchformTranslations}
            />
          </MapViewSearchControlsMobileWrapper>
          {children}
        </Stack>
      </StyledMapContainer>
    </RemoveScroll>
  )
}
